export enum QRType {
  PERSONAL_ITEM = 'PERSONAL_ITEM'
}
